import { Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { routes } from 'Constants/routes';

const RetryButton = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);

  const handleClick = (): void => {
    history.push(routes.DASHBOARD);
  };

  return (
    <Buttons.Classic
      label={t('DG.Retry.button')}
      mode="success"
      size="l"
      type="button"
      onClick={handleClick}
    />
  );
};

export default RetryButton;
